// <template>
//     <div class = "card" style = "margin-top: 10px">
//         <div class = "embed-responsive embed-responsive-16by9">
//             <img class="card-img-top" src="category.image" alt="Card image cap">
//         </div>
//         <div class="card-body">
//             <h5 class="card-title">{{category.name}}</h5>
//             <p class="card-text">{{category.description}}</p>
//             <a href="#" class="btn btn-primary">Go somewhere</a>
//         </div>
//     </div>
// </template>
// <script>
// export default {
//     name: CategoryBox,
//     props: ["category"],
//     methods: {

//     }
// }
// </script>

